import { createApp } from 'vue'
import App from './App.vue'
const app = createApp(App)
import store from './store'
import router from './router'


import '@/utils/permission'

//多语言
import { createI18n } from 'vue-i18n';
import zh from './assets/lang/zh.js';
const messages = {
    zh: zh,
}
const i18n = createI18n({
    locale: 'zh', // 当前语言
    fallbackLocale: 'zh',
    messages,
    legacy: false
})
// en_US  hi_IN  zh_CN
localStorage.setItem('language', 'zh_CN');



// ElementUI
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// 公共样式引入
import '@/assets/css/base.scss';

import * as ElementPlusIconsVue from '@element-plus/icons-vue'
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}


app.use(ElementPlus).use(i18n).use(store).use(router).mount('#app')
